import { render } from "./sicurezza.vue?vue&type=template&id=2780740c&bindings={\"navigate\":\"props\"}"
import script from "./sicurezza.vue?vue&type=script&lang=js"
export * from "./sicurezza.vue?vue&type=script&lang=js"

import "./sicurezza.vue?vue&type=style&index=0&lang=css"
script.render = render
/* custom blocks */
import block0 from "./sicurezza.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script